'use client';

import { useStoreMap } from 'effector-react';
import { getMenuItemsLengthParams } from '@nx-frontend/features/menu-tree';
import { MenuType, PORTAL_MENU_TYPE } from '@nx-frontend/shared/types';
import { SidebarPortalMenuSection } from './sidebar-portal-menu-section';

const menus: PORTAL_MENU_TYPE[] = [MenuType.PORTAL_SIDEBAR, MenuType.PORTAL_TOPBAR, MenuType.PORTAL_FOOTER];

export function SidebarPortalMenu() {
  const topbarItemsLength = useStoreMap(getMenuItemsLengthParams(MenuType.PORTAL_TOPBAR));
  const topbarAddDisabled = topbarItemsLength >= 5;

  return (
    <div className="pb-2">
      {menus.map((menuType) => {
        return (
          <SidebarPortalMenuSection
            key={menuType}
            menuType={menuType}
            addDisabled={topbarAddDisabled && menuType === MenuType.PORTAL_TOPBAR}
          />
        );
      })}
    </div>
  );
}
